import { render, staticRenderFns } from "./BindMeasurePoint.vue?vue&type=template&id=61874024&scoped=true"
import script from "./BindMeasurePoint.vue?vue&type=script&lang=js"
export * from "./BindMeasurePoint.vue?vue&type=script&lang=js"
import style0 from "./BindMeasurePoint.vue?vue&type=style&index=0&id=61874024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61874024",
  null
  
)

export default component.exports